@if(filledInfo && sectionData){
<div nz-row>
  @if(isAttrAvailable('isSnapReceived')){
  <div nz-col nzSpan="24" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"
    *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'isSnapReceived']">
    <div nz-row>

      <div nz-col nzSpan="12" [nzXs]="15" ngClass="font-weight-600 pt-2 ">
        {{ getAttributes("isSnapReceived").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="9" ngClass="pt-2  mobile-value-left-paddiing">
        {{ filledInfo?.isSnapReceived === true ? 'Yes' : filledInfo?.isSnapReceived === false ? 'No' : '-' }}
      </div>
    </div>
  </div>
  }
  @if(isAttrAvailable('isTanfReceived')){
  <div nz-col nzSpan="24" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"
    *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'isTanfReceived']">
    <div nz-row>

      <div nz-col nzSpan="12" [nzXs]="15" ngClass="font-weight-600 pt-2 ">
        {{ getAttributes("isTanfReceived").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="9" ngClass="pt-2  mobile-value-left-paddiing">
        {{ filledInfo?.isTanfReceived === true ? 'Yes' : filledInfo?.isTanfReceived === false ? 'No' : '-' }}
      </div>
    </div>
  </div>
  }
  @if(isAttrAvailable('isSsiReceived')){
  <div nz-col nzSpan="24" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"
    *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'isSsiReceived']">
    <div nz-row>

      <div nz-col nzSpan="12" [nzXs]="15" ngClass="font-weight-600 pt-2 ">
        {{ getAttributes("isSsiReceived").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="9" ngClass="pt-2  mobile-value-left-paddiing">
        {{ filledInfo?.isSsiReceived === true ? 'Yes' : filledInfo?.isSsiReceived === false ? 'No' : '-' }}
      </div>
    </div>
  </div>
  }
  @if(isAttrAvailable('isUnemployed')){
  <div nz-col nzSpan="24" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"
    *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'isUnemployed']">
    <div nz-row>

      <div nz-col nzSpan="12" [nzXs]="15" ngClass="font-weight-600 pt-2 ">
        {{ getAttributes("isUnemployed").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="9" ngClass="pt-2  mobile-value-left-paddiing">
        {{ filledInfo?.isUnemployed === true ? 'Yes' : filledInfo?.isUnemployed === false ? 'No' : '-' }}
      </div>
    </div>
  </div>
  }
  @if(isAttrAvailable('isVeteran')){
  <div nz-col nzSpan="24" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"
    *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'isVeteran']">
    <div nz-row>

      <div nz-col nzSpan="12" [nzXs]="15" ngClass="font-weight-600 pt-2 ">
        {{ getAttributes("isVeteran").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="9" ngClass="pt-2  mobile-value-left-paddiing">
        {{ filledInfo?.isVeteran === true ? 'Yes' : filledInfo?.isVeteran === false ? 'No' : '-' }}
      </div>
    </div>
  </div>
  }
  @if(filledInfo?.isVeteran && isAttrAvailable('isDisabilityComp')){
  <div nz-col nzSpan="24" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"
    *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'isDisabilityComp']">
    <div nz-row>

      <div nz-col nzSpan="12" [nzXs]="15" ngClass="font-weight-600 pt-2 ">
        {{ getAttributes("isDisabilityComp").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="9" ngClass="pt-2  mobile-value-left-paddiing">
        {{ filledInfo?.isDisabilityComp === true ? 'Yes' : filledInfo?.isDisabilityComp === false ? 'No' : '-' }}
      </div>
    </div>
  </div>
  }
</div>
}@else{
<nz-row>
  <p>No Data found</p>
</nz-row>
}